export class CompoundUtils {
  static readonly smallestAllowableValue = 0.5;
}
